"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledWrapper = exports.Image = exports.Text = exports.View = exports.styled = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* tslint:disable:completed-docs */
var styled = {
  Image: _styledComponents.default.img,
  Text: _styledComponents.default.div,
  View: _styledComponents.default.div
};
exports.styled = styled;
var View = "div";
exports.View = View;
var Text = "div";
exports.Text = Text;
var Image = "img";
exports.Image = Image;
var styledWrapper = _styledComponents.default;
exports.styledWrapper = styledWrapper;
//# sourceMappingURL=primitives.js.map